import { useEffect } from 'react';
import { BackHandler } from 'react-native';

// 返回true阻止返回
type backActionType = () => boolean;

export const useBackHandle = (backAction: backActionType) => {
    useEffect(() => {
        BackHandler.addEventListener('hardwareBackPress', backAction);
        return () => BackHandler.removeEventListener('hardwareBackPress', backAction);
    }, [backAction]);
};
